import { useQuery } from "@tanstack/react-query";
import API from "@/api";

function useNurseries() {
  const { isPending, error, data } = useQuery({
    queryKey: ["nurseries"],
    queryFn: API.getNurseries
  });

  return {
    isPending,
    error,
    data
  };
}

export default useNurseries;
